import { render } from "./PaneListBuildingParts.vue?vue&type=template&id=49f46fce&scoped=true&ts=true"
import script from "./PaneListBuildingParts.vue?vue&type=script&lang=ts"
export * from "./PaneListBuildingParts.vue?vue&type=script&lang=ts"

import "./PaneListBuildingParts.vue?vue&type=style&index=0&id=49f46fce&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\jonatan\\Documents\\Repos\\milva-online\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49f46fce"]])

export default __exports__